import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { showToast, NoData } from '@deeptrue-frontend/ui';
import api from 'api/api';
import { useFormatMessage } from 'components/IntlProvider';
import styled from 'styled-components/macro';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    border: '1px solid #CECECA',
    boxShadow: ' 0 4px 12px 0 rgba(0,0,0,0.1)',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  file: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '95%',
  },
  aggregate: {
    margin: '0.2rem 0',
  },
  cancel: {
    backgroundColor: '#b00020',
    color: 'white',
    '&:hover': {
      backgroundColor: '#b00020b0',
    },
  },
  animContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4rem',
    '& rect': {
      fill: 'transparent',
    },
  },
}));

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5rem;
`;

interface Props {
  linkId: string;
  organization: string;
  files: { name: string; path: string }[];
}

const Files = ({ linkId, organization, files }: Props) => {
  const classes = useStyles();
  const t = useFormatMessage();

  const onDownloadFileCsv = (file: { name: string; path: string }) => {
    api.resources
      .getSharedReportFile({
        organizationCodename: organization,
        linkId,
        fileId: file.path,
      })
      .then(({ data }) => {
        const isJson = file.name.includes('.json');
        const url = window.URL.createObjectURL(
          new Blob(isJson ? [JSON.stringify(data)] : [data])
        );

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
  };

  return (
    <div style={{ marginTop: '2rem', marginLeft: '2rem', width: '100%' }}>
      {files.length ? (
        files.map((file: { name: string; path: string }) => (
          <Grid
            item
            xs={12}
            md={4}
            key={file.name}
            onClick={() => onDownloadFileCsv(file)}
          >
            <Paper className={classes.paper}>
              <span className={classes.file}>{file.name}</span>
            </Paper>
          </Grid>
        ))
      ) : (
        <Wrapper>
          <NoData
            title={t(
              'project.statistic.bexio.nodata.report.title',
              'Waiting for survey data'
            )}
            description={t(
              'project.statistic.nodata.files.description',
              'We will now automatically send the survey to your audience. As soon as the first responses are available, the files will be generated.'
            )}
          />
        </Wrapper>
      )}
    </div>
  );
};

export default Files;
